<template>
<div class="business">
    <div class="fw">
        <div class="left">
            <p @click='detail(i,k)' v-for="(i,k) in data" :key='k'>{{i.title}}</p>
        </div>
        <div class="right">
            <p v-html="tdata">{{tdata}}</p>
        </div>
    </div>
</div>   
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    props: {
        data: Array,
    },
    data: () => ({
        tdata: ''
    }),
    watch: {
        data: {
            handler (newVal) {
                this.detail(newVal[0])
            },
            immediate: true
        }
    },
    methods: {
        detail (data) {
            let langType = localStorage.getItem('langType')
            this.$$$api.casesDetail({id: data.id}).then(res => {
                this.tdata = langType=="zh"?res.data.data.context:res.data.data.contextEn
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
@import "~styl/mixin.styl"

.business
    min-height 350px
    mt(20)
    .fw  
        display flex
        .left 
            width 20%
            p  
                fs(13)
                c(gray)
                _hover()
        .right 
            flex 1 
            padding-left 60px
            p
                text-indent 30px
                fs(14)
                op(.8)
                lh(30)
</style>



// WEBPACK FOOTER //
// src/components/business/default.vue